import { setQRCodeCopiedOpen } from "../../../store/features/profileSlice";

export const copyQRCodeToClipboard = async (
  qrCodeRef: React.RefObject<SVGSVGElement>,
  dispatch: any
) => {
  try {
    if (!qrCodeRef.current) return;

    const svgElement = qrCodeRef.current;

    const svgData = new XMLSerializer().serializeToString(svgElement);
    const svgBlob = new Blob([svgData], {
      type: "image/svg+xml;charset=utf-8",
    });

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();

    const url = URL.createObjectURL(svgBlob);

    await new Promise((resolve) => {
      img.onload = resolve;
      img.src = url;
    });

    canvas.width = img.width;
    canvas.height = img.height;

    ctx?.drawImage(img, 0, 0);

    const imgBlob = await new Promise<Blob>((resolve) => {
      canvas.toBlob((blob) => {
        if (blob) resolve(blob);
      }, "image/png");
    });

    const clipboardItem = new ClipboardItem({ "image/png": imgBlob });
    await navigator.clipboard.write([clipboardItem]);

    URL.revokeObjectURL(url);

    dispatch(setQRCodeCopiedOpen());
  } catch (error) {
    console.error("Error", error);
  }
};

export const downloadQRCode = async (
  qrCodeRef: React.RefObject<SVGSVGElement>
) => {
  try {
    if (!qrCodeRef.current) return;

    const svgElement = qrCodeRef.current;
    const svgData = new XMLSerializer().serializeToString(svgElement);
    const svgBlob = new Blob([svgData], {
      type: "image/svg+xml;charset=utf-8",
    });

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    const url = URL.createObjectURL(svgBlob);

    await new Promise((resolve) => {
      img.onload = resolve;
      img.src = url;
    });

    canvas.width = img.width;
    canvas.height = img.height;

    ctx?.drawImage(img, 0, 0);

    const dataUrl = canvas.toDataURL("image/png");

    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = "qr-code.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error", error);
  }
};
